// extracted by mini-css-extract-plugin
export default {"clickable":"ExceptionEntityTableRows_clickable__-j8o4","collapse":"ExceptionEntityTableRows_collapse__Xwk5D"};